// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_ax-b";
export var colorBlue = "_ax-8";
export var colorDot = "_ax-0";
export var colorDotLarge = "_ax-2";
export var colorDotSmall = "_ax-1";
export var colorGreen = "_ax-7";
export var colorGrey = "_ax-3";
export var colorOrange = "_ax-5";
export var colorPink = "_ax-a";
export var colorPurple = "_ax-9";
export var colorRed = "_ax-4";
export var colorYellow = "_ax-6";